import React, { useEffect, useRef, useState } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { StatusBar, Text, TextInput, AppState, LogBox, View } from 'react-native';
import {
    NavigationContainer,
    getStateFromPath as _getStateFromPath,
    getPathFromState as _getPathFromState,
    useNavigationContainerRef
} from '@react-navigation/native';
import { PortalProvider } from '@gorhom/portal';
import Theme, { ThemeProvider } from 'Theme';
import { APP_METADATA, linkConfig } from 'Options';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { QueryClientProvider, QueryClient } from 'react-query';

import { Device, lockToLandscape } from 'DeviceUtils';
import AppEntry from 'Pages/AppEntry';
import { StoreProvider } from 'Store';
import { ChannelsServiceContextProvider } from 'LocalGluons/components/ChannelsServiceContext';
import { FavoriteChannelsProvider } from 'LocalGluons/components/FavoriteChannelsContext/FavoriteChannelsContext';
import { RecordingsContextProvider } from 'LocalGluons/components/RecordingsContext/RecordingsContext';
import { EpgListModeContextProvider } from 'LocalGluons/components/EpgListModeContext/EpgListModeContext';
import { useLogger } from '@react-navigation/devtools';
import NavigationProps from '../Navigation/navigationPropsContext';
import { NavigationHelperProvider } from '../../context/NavigationHelper/NavigationHelperProvider';
import AppStack from '../Navigation';

LogBox.ignoreAllLogs();
// Font sizing configuration
Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.maxFontSizeMultiplier = 1.2;
TextInput.defaultProps = TextInput.defaultProps || {};
TextInput.defaultProps.maxFontSizeMultiplier = 1.2;

// TODO: Is this still used?
// eslint-disable-next-line no-underscore-dangle
global._INTERNALS = {
    data: {}
};

const Stack = createNativeStackNavigator();

try {
    if (Device.isAndroid) {
        StatusBar.setBackgroundColor(Theme.primaryBackgroundColor);
    } else {
        StatusBar.setBarStyle(Theme.statusBarTheme);
    }
} catch (error) {
    // Do nothing, this platform does not support StatusBar
}
export const dataToExport = {
    isDetail: false,
    idOfDeteail: null
};

const App = () => {
    const navigationRef = useNavigationContainerRef();

    useLogger(navigationRef);
    const [insertedPath, setInsertedPath] = useState(null);
    const [detailID, setDetailID] = useState(null);
    const [pathOptions, setPathOptions] = useState(null);
    useEffect(() => {
        // checkDetailPath(insertedPath);
        if (!Device.isTablet) return () => {};

        const onStateChange = () => {
            lockToLandscape();
        };

        const changeListener = AppState.addEventListener('change', onStateChange);
        return () => {
            changeListener.remove();
        };
    }, []);

    const queryClientRef = useRef(new QueryClient());

    const linking = {
        config: linkConfig,
        getStateFromPath: (path, options) => {
            if (/^\/detail\/program\/\.*/.test(path)) {
                setPathOptions(options.screens);
                setInsertedPath(path);
            }
            return _getStateFromPath(path, options);
        },
        getPathFromState(state, options) {
            let path;
            if (state.routes.length > 0) {
                if (state.routes[state.routes.length - 1].name === 'Login') {
                    path = 'login';
                } else if (state.routes[state.routes.length - 1].name === 'Logout') {
                    path = 'logout';
                }
            }

            return path || _getPathFromState(state, options);
        }
    };

    return (
        <GestureHandlerRootView style={{ flex: 1 }}>
            <NavigationContainer
                ref={navigationRef}
                documentTitle={{
                    formatter: (options) => {
                        const title = options?.headerTitle ? `${options.headerTitle} - ` : '';
                        return APP_METADATA.webHeaderName || 'Magio TV';
                    }
                }}
                linking={linking}
            >
                <NavigationProps>
                    <ThemeProvider>
                        <QueryClientProvider client={queryClientRef.current}>
                            <StoreProvider>
                                <RecordingsContextProvider>
                                    <FavoriteChannelsProvider>
                                        <EpgListModeContextProvider>
                                            <ChannelsServiceContextProvider>
                                                <NavigationHelperProvider>
                                                    <PortalProvider>
                                                        <AppEntry>
                                                            <AppStack
                                                                insertedPath={insertedPath}
                                                                pathOptions={pathOptions}
                                                            />
                                                        </AppEntry>
                                                    </PortalProvider>
                                                </NavigationHelperProvider>
                                            </ChannelsServiceContextProvider>
                                        </EpgListModeContextProvider>
                                    </FavoriteChannelsProvider>
                                </RecordingsContextProvider>
                            </StoreProvider>
                        </QueryClientProvider>
                    </ThemeProvider>
                </NavigationProps>
            </NavigationContainer>
        </GestureHandlerRootView>
    );
};

export default App;
